import {
  BannerButtons,
  BannerDescription,
  BannerStyled,
  BannerText,
} from './Banner.styled';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { CommonButton } from '../../../components/common/Forms/Button';
import { useCheckVersionUpdate } from '../../../hooks/version/useCheckVersionUpdate';

export const VersionUpdateBanner = () => {
  const { t } = useCommonTranslation();
  const { isVersionUpdated } = useCheckVersionUpdate({
    trigger: 'interval',
  });

  if (!isVersionUpdated) {
    return null;
  }

  return (
    <BannerStyled>
      <BannerDescription>
        <h2>{t('version-update-header')}</h2>
        <BannerText>{t('version-update-text')}</BannerText>
      </BannerDescription>
      <BannerButtons>
        <CommonButton
          onClick={() => {
            window.location.reload();
          }}
          variant={'primary'}
          size={'large'}
          data-testid={'version-update-reload'}
        >
          {t('version-update-reload')}
        </CommonButton>
      </BannerButtons>
    </BannerStyled>
  );
};
